import React from "react";

import { IoMdMusicalNote } from "@react-icons/all-files/io/IoMdMusicalNote";
import { MdMic } from "@react-icons/all-files/md/MdMic";
import { MdMicOff } from "@react-icons/all-files/md/MdMicOff";

function Music() {
  const [playing, setPlaying] = React.useState(false);
  const [isOnMute, setIsOnMute] = React.useState(false);

  const url = "/deftones.mp3";
  const audioRef = React.useRef(new Audio(url));
  React.useEffect(() => {
    if (isOnMute) {
      audioRef.current.volume = 0;
    } else {
      audioRef.current.volume = 0.2;
    }
  }, [isOnMute]);
  const play = () => {
    setPlaying(true);
    audioRef.current.volume = 0.2;
    audioRef.current.play();
    audioRef.current.loop = true;
  };
  const pause = () => {
    setPlaying(false);
    audioRef.current.pause();
  };
  return (
    <div>
      <div className="z-[1000] relative">
        {playing && (
          <div className="rounded-full animate-ping fixed hover:scale-110 duration-500 ease-in-out bottom-[10px] right-[10px]  md:right-6 md:bottom-6 lg:right-10 lg:bottom-10   bg-primary p-3 md:p-4">
            <IoMdMusicalNote className="text-tertiary text-[16px] md:text-[25px]" />
          </div>
        )}
        <div
          title="Music"
          onClick={playing ? pause : play}
          className="cursor-pointer rounded-full fixed hover:scale-110 duration-500 ease-in-out  bottom-[10px] right-[10px]  md:right-6 md:bottom-6 lg:right-10 lg:bottom-10   bg-primary p-3 md:p-4"
        >
          <IoMdMusicalNote className="text-tertiary text-[16px] md:text-[25px]" />
        </div>
        <div>
          <div
            onClick={() => setIsOnMute((prev) => !prev)}
            className=" hidden md:flex cursor-pointer rounded-full fixed hover:scale-110 duration-500 ease-in-out bottom-[10px] right-[10px]  md:right-6 md:bottom-6 lg:right-10 lg:bottom-10  bg-tertiary w-6 h-6  justify-center items-center"
          >
            {isOnMute ? (
              <MdMicOff className="text-secondary text-[16px] md:text-[15px]" />
            ) : (
              <MdMic className="text-secondary text-[16px] md:text-[15px]" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Music;
